import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

import { ButtonDirective } from '../button/button.directive';
import { IconDirective } from '../icon/icon.directive';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
  imports: [MatIconModule, IconDirective, TranslocoPipe, ButtonDirective],
  host: {
    class: 'tt-no-results',
    '[class.tt-no-results--small]': 'size() === "small"',
  },
})
export class NoResultsComponent {
  public size = input<'normal' | 'small'>('normal');
  public title = input('NoSearchResults');
  public message = input('');
  public icon = input<string | undefined>('no-results');
  public iconSize = input<number | undefined>(undefined);
  public effectiveIconSize = computed(() => this.iconSize() ?? (this.size() === 'small' ? 16 : 32));
  public actionIcon = input<string>();
  public actionLabel = input<string>();
  public actionOptions = input<{ value: string; label: string }[]>();

  public actionClicked = output<MouseEvent>();
}
